angular.module('angus.directives').directive('sysAdminTools', [
    'actionViewTemplates',
    function(actionViewTemplates) {
        return {
            scope: {
                model: "=",
                settings: "=",
                windowId: "="
            },
            restrict: 'A',
            templateUrl: actionViewTemplates.sysAdminTools
        }
    }
])